import React, { useState } from 'react';
import { Button, Popover } from 'antd';
import PropTypes from 'prop-types';
import SortContent, { setSortColumn, setGetSortRows } from './sort';
import FilterContent from './filters';
import styled from './styled';
const { styleTitle, mr, btn, btnResult, flexEnd, popupBtnLabel } = styled;
let handleFilterPopup, handleSortPopup;
let flag = true;
const defaultProps = {
  sortVisible: true,
  filterVisible: true,
  listenSort: null,
  listenFilters: null,
  sortColumns: [],
  sortRows: []
};

function FilterComponent(props) {
  const { sortColumns, sortRows, sortVisible, listenSort, isResult } = props;
  const { filterVisible, listenFilters } = props;
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const titleTemplate = (title, closePopup) => (
    <div style={styleTitle}>
      <span>{title}</span>
      <span onClick={() => closePopup(false)}>X</span>
    </div>
  );

  const sortContentTemplate = <SortContent {...{ listenSort }} />;
  const filterContentTemplate = <FilterContent {...{ listenFilters }} />;

  handleSortPopup = () => {
    setIsFilterOpen(false);
    setIsSortOpen(!isSortOpen);

    if (!isSortOpen && flag) {
      flag = false;
      setTimeout(() => {
        setSortColumn(sortColumns);
        setGetSortRows(sortRows);
      }, 50);
    }
  };

  handleFilterPopup = () => {
    setIsSortOpen(false);
    setIsFilterOpen(!isFilterOpen);
  };

  return (
    <>
      <div style={flexEnd}>
        <div>
          {' '}
          <p style={popupBtnLabel}>Sort</p>
          {sortVisible && (
            <Popover
              placement="bottomRight"
              title={titleTemplate('Sort', setIsSortOpen)}
              content={sortContentTemplate}
              trigger="click"
              visible={isSortOpen}>
              <Button
                onClick={handleSortPopup}
                style={isResult ? btnResult : btn}>
                <i className="fa fa-sort" color="#dfdfdf"></i>
              </Button>
            </Popover>
          )}
        </div>
        <div style={mr} />
        <div>
          {' '}
          <p style={popupBtnLabel}>Filter</p>
          {filterVisible && (
            <Popover
              placement="bottomRight"
              title={titleTemplate('Filter', setIsFilterOpen)}
              content={filterContentTemplate}
              trigger="click"
              visible={isFilterOpen}>
              <Button onClick={handleFilterPopup} style={btn}>
                <i className="fa fa-filter"></i>
              </Button>
            </Popover>
          )}
        </div>
      </div>
      <br />
    </>
  );
}

FilterComponent.defaultProps = defaultProps;
FilterComponent.propTypes = {
  sortVisible: PropTypes.bool,
  filterVisible: PropTypes.bool,
  listenSort: PropTypes.func,
  listenFilters: PropTypes.func,
  sortColumns: PropTypes.array,
  sortRows: PropTypes.array
};

export { setGetSortRows, handleFilterPopup, handleSortPopup };
export default FilterComponent;
